import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { Observable } from 'rxjs';
import { DevicesProvider } from './../../providers/devices/devices';
import { TasksProvider } from './../../providers/tasks/tasks';
import { Component, ViewChild, ViewEncapsulation , OnInit} from '@angular/core';
import { IonicPage, NavController, NavParams, Platform, AlertController } from 'ionic-angular';
import { TaskQL, Task, TaskData } from '../../providers/tasks/models';
import { ENV } from '../../environments/environment';

@IonicPage()
@Component({
  selector: 'page-task-code',
  templateUrl: 'task-code.html',
  encapsulation: ViewEncapsulation.None,
})
export class TaskCodePage {
  private task: TaskQL;
  private code: string = '';
  private ready: boolean;
  private taskData: TaskData;
  private extras: any;
  private isrepair: boolean = false;
  private isreplace: boolean = false;
  private serial: string;
  private showTypeBox: boolean = false;
  showBrowserScanner: boolean = false;
  private torch: boolean = false;
  private scanCodeVerified: boolean = false;
  private enableFlaslight: boolean = false;
  devicePass: string;

  cameras: any;
  selectedCamera: any = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private barcodeScanner: BarcodeScanner,
    private tasksProvider: TasksProvider,
    private devicesProvider: DevicesProvider,
    public platform: Platform,
    public alertCtrl: AlertController
  ) {
    this.task = this.navParams.get('task');
    this.extras = this.navParams.get('extras');
    this.isrepair = this.extras && this.extras.isrepair ? this.extras.isrepair : null;
    this.isreplace = this.extras && this.extras.isreplace ? this.extras.isreplace : null;
  }

  ionViewDidLoad() {}
  ionViewDidEnter() {
    this.taskData = this.tasksProvider.getTaskData(this.task.id);
    // if (this.taskData.code) this.code = this.taskData.code;
    // if (this.isrepair && !this.isreplace && this.taskData.verified) {
    //   this.code = this.devicesProvider.getSerial(this.taskData.verified);
    // }

    this.readyCheck();
  }

  isCordova() {
    return this.platform.is('cordova');
  }
  async photoLight(){
    this.torch = !this.torch;
  }

  scanCode() {
    this.showTypeBox = false;
    const isCordova = this.isCordova();
    if (isCordova) {
      this.barcodeScanner.scan().then(
        barcodeData => {
          this.code = barcodeData.text;
          this.checkAndVerifyCode().subscribe(result => {
            if (result) {
              this.readyCheck();
              this.updateTask();
            }
          });
        },
        err => {
          // error
          alert(err);
          console.log(err);
        }
      );
    } else {
      this.browserScanner();
    }
  }

  noCordovaUpdate() {
    this.checkAndVerifyCode().subscribe(result => {
      if (result) {
        this.readyCheck();
        this.updateTask();
      }
    });
  }

  checkAndVerifyCode() {
    return Observable.create(observer => {
      let flag = false;
      // this.serial = this.devicesProvider.qrCodeToSerial(this.code);
      this.devicesProvider.qrCodeParseValidated(this.code, this.task.deviceType).subscribe(
        serial => {
          this.serial = serial;
          if (this.isrepair || this.task.type === "deinstallation") {
            if (this.task.install && (this.serial === this.task.install.serial || this.task.install.oldSerial === this.serial)) {
              flag = true;
            } else {
              flag = false;
              let message = 'Device serial does not match. Make sure this is the correct device.';
              let alert = this.alertCtrl.create({
                title: 'Error!',
                message: message,
                buttons: ['OK']
              });
              alert.present();
            }
          } else {
            flag = true;
          }
          observer.next(flag);
        },
        e => {
          let alert = this.alertCtrl.create({
            title: 'Error!',
            message: e,
            buttons: ['OK']
          });
          alert.present();
          //observer.error(e);
        }
      );
    });
  }

  readyCheck() {
    let flag = this.code.length > 0;
    this.ready = flag;
  }

  isFirstTime() {
    return this.isreplace || (this.code && this.code.length > 0) ? false : true;
  }

  validateCode(serial) {
    return Observable.create(observer => {
      let flag = false;
      if (
        this.task.deviceType === Task.DeviceTypeEnum.FireAlarm &&
        serial.toLowerCase().indexOf('fireal') > 0
      ) {
        // check serial
        flag = true;
      } else if (
        this.task.deviceType === Task.DeviceTypeEnum.Security &&
        serial.toLowerCase().indexOf('secdev') > 0
      ) {
        // check serial
        flag = true;
      } else if (
        this.task.deviceType === Task.DeviceTypeEnum.Geyser &&
        serial.toLowerCase().indexOf('geyser') > 0
      ) {
        // check serial
        flag = true;
      } else if (
        this.task.deviceType === Task.DeviceTypeEnum.Congey &&
        serial.toLowerCase().indexOf('congey') > 0
      ) {
        // check serial
        flag = true;
      }

      if (flag) {
        observer.next('success');
      } else {
        observer.error('error');
      }
    });
  }

  updateTask() {
    let type = !this.isrepair ? 'code' : 'verified';
    let data = ['data'];
    this.validateCode(this.serial).subscribe(
      () => {
        if (this.isreplace) {
          this.tasksProvider.updateTaskData(this.task, 'newSerial', this.serial).subscribe(data => {
            // check
            console.log('set active', data);
          });
        }

        let partial;
        const serial = this.serial;
        if (this.isreplace) {
          partial = {
            status: 'inprogress',
            install: {
              newSerial: serial,
              activationPassword: this.devicePass
            }
          };
        } else {
          partial  = {
            status: 'inprogress',
            install: {
              serial: serial,
              activationPassword: this.devicePass
            }
          };
        }
        this.tasksProvider.updateTaskPartial(this.task.id, partial).subscribe(
          updateResult => {
            this.tasksProvider.updateTaskData(this.task, type, this.serial).subscribe(data => {
              this.tasksProvider.updateTaskData(this.task, 'test', null).subscribe(data => {
                this.tasksProvider.setSelectedTask(updateResult);
                this.navCtrl.pop();
              });
            });
          },
          err => {
            let message =
              err.error && err.error.message
                ? err.error.message
                : 'Failed to update task, please check your internet connection and try again.';
            let alert = this.alertCtrl.create({
              title: 'Error',
              message: message,
              buttons: ['OK']
            });
            alert.present();
          }
        );
      },
      error => {
        let message =
          'The serial does not match the device for this task. Please check if this is the correct serial of the device to be installed.';
        let alert = this.alertCtrl.create({
          title: 'Error',
          message: message,
          buttons: ['OK']
        });
        alert.present();
      }
    );
  }

  parseInputCode(code){
    let input = code.replace('GEYSER', '').replace('SECDEV', '').replace('CONGEY', '');
    input = input.replace("snsecdev:", '').replace("sngeyser:", '').replace('sncongey:', '')
    input = input.trim()

    if (input.length === 8 && !this.task.deviceType.includes('fire')) {
      if (this.task.deviceType.includes('geyser')) {
        input = 'sngeyser:' + input + 'GEYSER'
      } else if (this.task.deviceType.includes('secdev')) {
        input = 'snsecdev:' + input + 'SECDEV'
      } else if (this.task.deviceType.includes('congey')) {
        input = 'sncongey:' + input + 'CONGEY'
      }
    }
    return input;
  }

  confirmCode(evt){
    this.enableFlaslight = false;
    this.showBrowserScanner = false;
    this.torch = false;
    let value = this.parseInputCode(evt);
    this.scanCodeVerified = false;
    this.code = value;
    if(this.code.includes("=")){
      this.devicePass = value.substring(value.indexOf("=")+1);
      localStorage.setItem("lastPass", this.devicePass);
    }
    this.checkAndVerifyCode().subscribe(result => {
      if (result) {
        this.showBrowserScanner = false;
        this.scanCodeVerified = true;
      }
    });
  }

  onHasPermission(evt){
    // alert("Perm: "+JSON.stringify(evt))
  }
  onCamerasFound(evt){
    this.enableFlaslight = true;
    // alert("CAM: "+JSON.stringify(evt))

    this.cameras = evt.filter(cam => {
      return !cam.label.includes("IR");
    });

    if(this.cameras.length > 0){
      this.selectedCamera = this.cameras[0];
    }
  }

  onTorchCompatible(evt){
    // alert("TOurch: "+JSON.stringify(evt))
  }
  camerasNotFoundHandler(evt){
    // alert("NOCAM: "+JSON.stringify(evt))
  }
  showQrTypeBox(){
    if(!ENV.isprod && this.task?.install?.serial && this.code === '') this.code = this.task.install.serial;

    this.enableFlaslight = false;
    this.showBrowserScanner = false;
    this.scanCodeVerified = false;
    this.torch = false;
    this.showTypeBox = true;
  }
  browserScanner(){
    this.showBrowserScanner = true;
  }

  getCamera(evt){
    return this.selectedCamera;
  }
}



// WEBPACK FOOTER //
// ./src/pages/task-code/task-code.ts